const deCom = decodeURIComponent;
const enCom = encodeURIComponent;

export function getQueryStringArgs(str = '') {
  const qs = str.length > 0 ? str.substring(1) : '';
  const args = {};

  const items = qs.length ? qs.split('&') : [];

  for (let i = 0, len = items.length; i < len; i += 1) {
    const item = items[i].split('=');
    const name = deCom(item[0]);
    const value = deCom(item[1]);

    if (name.length) args[name] = value;
  }

  return args;
}

export function addURLParam(url, name, value) {
  let result = url;
  result += (result.indexOf('?') === -1) ? '?' : '&';
  result += `${enCom(name)}=${enCom(value)}`;
  return result;
}

export function addURLParams(url, params = {}) {
  let result = url;
  Object
    .keys(params)
    .forEach((key) => {
      result = addURLParam(result, key, params[key]);
    });

  return result;
}

export function getPathNameUrl() {
  let origin = window.location.origin;
  let index = origin.lastIndexOf('.');
  if (index >= 0) {
    let pathname = origin.substring(0, index);
    return pathname;
  }
}
export function deleteURLParams(name) {
  var loca = window.location;
  var baseUrl = loca.origin + loca.pathname + "?";
  var query = loca.search.substr(1);
  if (query.indexOf(name) > -1) {
    var obj = {}
    var arr = query.split("&");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    // eslint-disable-next-line no-useless-escape
    var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    return url
  } else {
    return window.location.href;
  }
}
